import { replayPillLabel } from '@/lib/replay-mark';
import type { ReplayMode } from '@matter_extractor/shared';

/**
 * The violet pill of a replay (rejeu.md §12, issue #193): « rejeu · strict » or
 * « rejeu · complété ».
 *
 * One component for the three places that wear it - the column Lien of the list,
 * the head of the parcours and the head of the conversation - so the three read
 * the same. Violet (`violet-tint`, `violet-deep`) because no status and no
 * version carries it: it cannot be mistaken for « en cours » (bleu ciel) or for a
 * development version.
 *
 * It says the MODE and nothing else. What the replay was played FROM is the
 * label under it on the list, and the panel of the parcours.
 */

export interface ReplayPillProps {
  readonly mode: ReplayMode;
  /** The mark a suite reads this pill by; it differs on the three screens. */
  readonly testId: string;
}

export function ReplayPill({ mode, testId }: ReplayPillProps) {
  return (
    <span
      data-testid={testId}
      data-mode={mode}
      className="inline-flex items-center whitespace-nowrap rounded-pill bg-violet-tint px-2.5 py-0.5 font-semibold text-violet-deep text-xs"
    >
      {replayPillLabel(mode)}
    </span>
  );
}
